import {albumItemActionTypes} from '../actions/album-item-action-types';
import {assetContainerTypes} from '../../assetContainer/actions/asset-container-action-types';
import {infoPanelActionTypes} from '../../infoPanel/actions/infoPanel-action-types';
import {addSelected, removeItem, clearAllSelections, updateObjectInArrayById} from '../../common/reducer-helpers.js';

const initialAlbumState = {
    albumItems: [],
    itemSlider: [],
    selectedItem: [],
    currentAssetShown: 0,
    parentAlbum: {},
    offset: 0,
    isComplete: false,
    collectionId: -1,
    max: 0,
    lastReceived: 0,
    emptyAlbum: true,
    showAlbumId: -1,
    amIfetching: false,
    amIHovering: false,
    scrollPosition: 0
};

export const albumItems = (state = initialAlbumState, action) => {
    switch (action.type) {
        case albumItemActionTypes.ALBUM_ITEM_UPDATED:{
            if(action.albumItem == null){
                return state;
            }
            let newAlbumItems = []
            action.albumItem.isLoaded=true
            for(let i=0;i<state.albumItems.length;i++){
                if(state.albumItems[i].id == action.id){
                    newAlbumItems.push(action.albumItem);
                }else{
                    newAlbumItems.push(state.albumItems[i]);
                }
            }
            let newItemSlider = [];
            for(let i=0;i<state.itemSlider.length;i++){
                if(state.itemSlider[i].id == action.id){
                    newAlbumItems.push(action.albumItem);
                }else{
                    newAlbumItems.push(state.itemSlider[i]);
                }
            }
            return {...state,albumItems:newAlbumItems,itemSlider:newItemSlider}
        }
        case albumItemActionTypes.ALBUM_ITEM_SCROLL:
            return {...state, scrollPosition: action.scrollPosition}
        case albumItemActionTypes.ALBUM_ITEMS_RECEIVED: {
            var isComplete = false;
            if (state.showAlbumId === action.collectionId) {
                if (action.albumItems.length === 0) {
                    isComplete = true;
                }
                else {
                    isComplete = action.count <= action.albumItems.length;
                }
                let albumItemsArray = [];
                if(state.albumItems.length !== action.count){
                    albumItemsArray = new Array(action.count);
                    for(let i=0;i<action.count;i++){

                        albumItemsArray[i] = {
                            isLoaded:false,
                            displayOrder:i,
                            customCollectionId: action.collectionId
                        };
                        if(typeof(action.ids) !== "undefined" && action.ids.length === action.count){
                            albumItemsArray[i].id = action.ids[i];
                        }
                    }
                }else{
                    albumItemsArray = state.albumItems.slice(0);
                }
                for(let i=0; i< action.albumItems.length; i++){
                    albumItemsArray[i+action.offsetStart] = action.albumItems[i];
                    albumItemsArray[i+action.offsetStart].isLoaded = true;
                    albumItemsArray[i+action.offsetStart].customCollectionId = action.collectionId;
                }
                albumItemsArray = albumItemsArray.map(item => {item.rotation = 0; return item;});
                return {
                    ...state,
                    albumItems: albumItemsArray,
                    offset: parseInt(action.offset, 10),
                    isComplete,
                    collectionId: action.collectionId,
                    max: action.max,
                    lastReceived: Date.now(),
                    count: parseInt(action.count, 10),
                    emptyAlbum: parseInt(action.count, 10) < 1,
                    amIfetching: false

                };
            }
            else {
                return {...state, amIfetching: false};
            }
        }
        case albumItemActionTypes.ALBUM_SHOW:
            return {
                ...state,
                showAlbumId: parseInt(action.id, 10)
            };

        case albumItemActionTypes.ALBUM_ITEMS_REQUEST:
            return {
                ...state,
                amIfetching: true
            };
        case albumItemActionTypes.ALBUM_ITEM_HOVER:
            return {
                ...state,
                amIHovering: action.hover
            };


        case albumItemActionTypes.ALBUM_ITEMS_FAILED:
            return {
                ...state,
                amIfetching: false
            };
        case albumItemActionTypes.CLEAR_ALBUM_ITEMS:
            return {
                ...state,
                albumItems: [],
                selectedItem: [],
                offset: 0,
                isComplete: false,
                showAlbumId: -1,
                amIfetching: false
            };

        case albumItemActionTypes.CLEAR_ALBUM_ITEMS_OFFSET:
            return {...state, offset: 0, isComplete: false, amIfetching: false};

        case albumItemActionTypes.ALBUM_ITEMS_SLIDER_RECEIVED:
            var itemsRecieved = [];
            if (action.isReversed) {
                itemsRecieved = [...action.albumItems, ...state.itemSlider];
            } else {
                if(action == null || action.albumItems == null || state.itemSlider == null ){
                    return state;
                }
                itemsRecieved = [...state.itemSlider, ...action.albumItems];
            }
            itemsRecieved = itemsRecieved.filter((item, index, self) => index === self.findIndex(t => t.id === item.id));

            itemsRecieved = itemsRecieved.filter(item => item.thumbnail != null);
            itemsRecieved = itemsRecieved.map(item => {item.rotation = 0; return item;});
            return {
                ...state,
                itemSlider: itemsRecieved,
                // offset:
                //     (state.collectionId !== -1) & (state.collectionId !== action.collectionId) ? 0 : parseInt(action.offset, 10),
                // isComplete: action.isComplete,
                // collectionId: action.collectionId,
                // count: action.count,
                // max: action.max.action,
                isReversed: action.isReversed
            };
        case albumItemActionTypes.CLEAR_ALBUM_ITEMS_SLIDER:
            return {...state, itemSlider: []};
        case albumItemActionTypes.ALBUM_ITEM_SLIDER_REQUEST:
            return {
                ...state,
                isComplete: action.isComplete
            };
        case albumItemActionTypes.ALBUM_ITEMS_SLIDER_FAILED:
            return state;

            case albumItemActionTypes.ALBUM_ITEM_ROTATE_SUCCESS:
            return {
                ...state,
                itemSlider: state.itemSlider.map(item => 
                    {
                        if (item.id === action.id){
                            item.rotation = action.rotation; 

                        }
                       
                   return item;}),
                albumItems: state.albumItems.map(item => 
                    {
                        if (item.id === action.id){
                            item.rotation = action.rotation; 

                        }
                       
                   return item;}),
                
            };
        case albumItemActionTypes.ALBUM_ITEM_SELECTED: {
            let selectedAlbumItems = addSelected(state.albumItems, action.albumItemId, true)
            return {
                ...state,
                albumItems: selectedAlbumItems,
                selectedItem: selectedAlbumItems.filter(item => item.selected).map(item => item.id)
            };
        }
        case albumItemActionTypes.ALBUM_ITEM_DESELECTED: {
            let selectedAlbumItems = addSelected(state.albumItems, action.albumItemId, false);
            return {
                ...state,
                albumItems: selectedAlbumItems,
                selectedItem: state.selectedItem.filter(item => item !== action.albumItemId)
            };
        }

        case albumItemActionTypes.ALBUM_IMAGE_CURRENT_UPDATED:
            return {
                ...state,
                selectedItem: [action.imageId],
                currentAssetShown: action.imageId
            };

        case albumItemActionTypes.CLEAR_ALBUM_ITEM_SELECTION:
            return {
                ...state,
                albumItems: clearAllSelections(state.albumItems),
                selectedItem: [],
                offset: 0
            };

        case albumItemActionTypes.ALBUM_ITEM_DELETED: {
            var selectedItems = state.selectedItem;
            var albumItems = state.albumItems;
            var itemSlider = state.itemSlider;

            action.ids.forEach(deleteId => {
                const index = albumItems.findIndex(item => item.id === deleteId);

                const fullScreenIndex = itemSlider.findIndex(item => item.id === deleteId);

                if (fullScreenIndex > -1) {
                    itemSlider = removeItem(itemSlider, fullScreenIndex);
                }

                const selectedIndex = selectedItems.indexOf(deleteId);

                if (selectedIndex > -1) {
                    selectedItems = removeItem(selectedItems, selectedIndex);
                }

                albumItems = removeItem(albumItems, index);
            });
            return {
                ...state,
                albumItems: albumItems,
                selectedItem: selectedItems,
                itemSlider
            };
        }
        case albumItemActionTypes.ALBUM_PARENT_RECEIVED: {
            return {
                ...state,
                parentAlbum: action.album,
                collectionId: action.album.id
            };
        }

        case assetContainerTypes.ASSET_CONTAINER_CANCEL_RESORT: {
            return {
                ...state,
                
                albumItems: action.originalValues
            };
        }

        case infoPanelActionTypes.INFO_PANEL_ASSET_UPDATE_REQUEST_ALBUM: {
            return {
                ...state,
                
                itemSlider: updateObjectInArrayById(state.itemSlider,action.updateData,action.id)
            };
        }

        
        





        case assetContainerTypes.ASSET_CONTAINER_MOVE_ASSET_AFTER:{
            if(action.element.assetId === action.element.moveAfterAssetId){
                return state;
            }
            let assetCollection=state.albumItems.slice();
           
            
            let moveItemIndex = -1;
            let moveToItemIndex = -1;
            //moveAfterItemId
            for(let i=0;i<assetCollection.length;i++){
                if(assetCollection[i].id === action.element.assetId){
                    moveItemIndex=i;
                }else if(assetCollection[i].id === action.element.moveAfterAssetId){
                    moveToItemIndex = i;
                }
                if(moveItemIndex !== -1 && moveToItemIndex !== -1){
                    break;
                }
            }
            let originalSortOrder = assetCollection[moveToItemIndex].displayOrder;
            assetCollection[moveItemIndex].displayOrder = originalSortOrder;
            assetCollection[moveItemIndex].modified=true;
            if(moveItemIndex < moveToItemIndex){
                //i.e. #3 => #5
                for(let i=moveItemIndex+1;i<=moveToItemIndex;i++){
                    assetCollection[i].displayOrder = assetCollection[i].displayOrder - 1;
                    assetCollection[i].modified = true;
                }
            }else{
                for(let i=moveItemIndex-1;i>=moveToItemIndex;i--){
                    assetCollection[i].displayOrder = assetCollection[i].displayOrder + 1;
                    assetCollection[i].modified = true;
                }
            }

            assetCollection = assetCollection.sort((a,b) =>  (a.displayOrder-b.displayOrder));
            return {...state, albumItems: assetCollection};
        }
        case infoPanelActionTypes.INFO_PANEL_ASSET_UPDATE_SUCCESS: {
            const cceId = action.id;
            const infoData = action.updateData;
            const newAlbumItems = state.albumItems.map(it => {
                if (it.id === cceId) {
                    return {
                        ...it,
                        title: infoData.title,
                        description: infoData.description,
                        createDate: infoData.createDate || it.createDate
                    }
                } else {
                    return it;
                }
            })
            return {...state, albumItems: newAlbumItems}
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/album-view/reducers/album-item-reducer.js